<template>
  <section id="carrier" class="carrier">
    <div class="join-header">
      <a href="">Hast du Lust Teil des Teams zu werden? Bewerbe dich jetzt!</a>
    </div>
    <div class="join">
      <div class="text">
        <span>
          Wir suchen immer öfters eine neue Unterstützung in unserem Team! Schicke uns bitte deine vollständige Bewerbung an
          <a href="">gartenfeewbach@aol.com</a> oder
          per Post an die untenstehende Adresse.
        </span>
      </div>
      <div class="image">
        <b-img src="../../assets/images/team-ad.png" />
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Carrier',
  }
</script>

<style lang="scss">
  @import '../../assets/styles/home/carrier.scss';
</style>
